import {
  faShield,
  faShieldSlash,
  faShieldCheck,
} from '@fortawesome/pro-regular-svg-icons'
import React from 'react'

import { EInsuranceMetaStatus } from '@flecto/types/src/enums/EInsuranceMetaStatus'
import { Icon, iconInsuranceOn } from '@flecto/ui'

import { useInsuranceManagerContext } from '../../../provider'

export default function useStatusIcon(): React.ReactElement {
  const { insurances } = useInsuranceManagerContext()
  const status = insurances.meta?.metaStatus ?? EInsuranceMetaStatus.READY

  const icons = new Map([
    ['ready', faShield],
    ['expired', faShieldSlash],
    ['pending', faShield],
    ['active', faShieldCheck],
  ])

  const colors = new Map([
    ['ready', 'gray'],
    ['expired', 'gray'],
    ['pending', 'gray'],
    ['active', 'brand'],
  ])

  const icon = icons.get(status) ?? faShield
  const color = colors.get(status)

  if (insurances.isClaimPeriod) {
    return <Icon icon={iconInsuranceOn} color='blue.6' size='lg' />
  }

  if (status === EInsuranceMetaStatus.ACTIVE) {
    return (
      <Icon
        color={color}
        icon={iconInsuranceOn}
        withCircleBackground
        size='sm'
      />
    )
  }

  return <Icon icon={icon} color={color} withCircleBackground size='sm' />
}
